export const Top = 'top';
export const Left = 'left';
export const Right = 'right';
export const Bottom = 'bottom';
export const Center = 'center';

export const Vertical = 'vertical';

export const Start = 'start';
export const Middle = 'middle';
export const End = 'end';

export const Index  = 'index';
export const Label  = 'label';
export const Offset = 'offset';
export const Perc   = 'perc';
export const Perc2  = 'perc2';
export const Value  = 'value';

export const GuideLabelStyle = 'guide-label';
export const GuideTitleStyle = 'guide-title';
export const GroupTitleStyle = 'group-title';
export const GroupSubtitleStyle = 'group-subtitle';

export const Symbols = 'symbol';
export const Gradient = 'gradient';
export const Discrete = 'discrete';

export const Size = 'size';
export const Shape = 'shape';
export const Fill = 'fill';
export const Stroke = 'stroke';
export const StrokeWidth = 'strokeWidth';
export const StrokeDash = 'strokeDash';
export const Opacity = 'opacity';

// Encoding channels supported by legends
// In priority order of 'canonical' scale
export const LegendScales = [
  Size,
  Shape,
  Fill,
  Stroke,
  StrokeWidth,
  StrokeDash,
  Opacity
];

export const Skip = {
  name: 1,
  style: 1,
  interactive: 1
};

export const zero = {value: 0};
export const one = {value: 1};
